import { useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../../api";
import useShowToast from "../../../hooks/useShowToast";

/**
 * Custom hook to set users as members.
 * @param refetchUsers - Function to refetch the users list after update
 * @returns Object containing the setAsMember function and loading state
 */
function useSetAsMember() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { successToast, errorToast } = useShowToast();

  const setAsMember = async (selectedUserIds: number[]) => {
    setIsLoading(true);
    try {
      await api.bulkUpdateUsers({
        user_ids: selectedUserIds,
        is_member: true,
      });
      if (api?.error) {
        errorToast({
          title: t("club_management.users.set_as_member.error_title"),
          description: api.error?.data as string,
        });
        return;
      }
      successToast({
        title: t("club_management.users.set_as_member.success_title"),
        description: t("club_management.users.set_as_member.success_description", {
          count: selectedUserIds.length,
        }),
      });
    } catch (error) {
      errorToast({
        title: t("club_management.users.set_as_member.error_title"),
        description: t("club_management.users.set_as_member.error_description"),
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    setAsMember,
    isLoading,
  };
}

export default useSetAsMember;
